export const LIBRARY_CARD_LOAD = 'LIBRARY_CARD_LOAD'
export const LIBRARY_CARD_LOAD_SUCCESS = 'LIBRARY_CARD_LOAD_SUCCESS'
export const LIBRARY_CARD_CREATED = 'LIBRARY_CARD_CREATED'
export const LIBRARY_CARD_CHANGED = 'LIBRARY_CARD_CHANGED'
export const LIBRARY_CARD_REMOVED = 'LIBRARY_CARD_REMOVED'
